import React, { useState } from "react";
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import { ToastAlertError, ToastAlertSuccess } from "../../../reauseble";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { RiEyeOffFill } from "react-icons/ri";
import { FaEye } from "react-icons/fa";
import Spinner from 'react-bootstrap/Spinner';

const RegisterModal = ({ modalShow, setModalShow }) => {

	const [modalType, setModalType] = useState("Login");
	const [error, setError] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [isLoading, setIsLoading] = useState(false);


	const handleFormSubmit = (e) => {
		e.preventDefault();
		const data = new FormData(e.target);

		const values = Object.fromEntries(data.entries());
		const hasEmptyValues = Object.values(values).some(value => value === '');

		if (!hasEmptyValues) {
			if (values.password !== values.confirmPassword) {
				setError("Passwords do not match");
			} else {
				setIsLoading(true);
				setError("");
				CoreHttpHandler.request(
					"shareholder_education",
					"register",
					{
						...values
					},
					(res) => {
						localStorage.setItem("user_details", JSON.stringify(res.data.data.customer.customer));
						localStorage.setItem("token", res.data.data.customer.token);
						ToastAlertSuccess(res.data.data.customer.message);
						setModalShow(false);
						setIsLoading(false);
						// ToastAlertSuccess("Registered Successfully");
					},
					(err) => {
						ToastAlertError(
							err?.response?.data?.message
								? err?.response.data.message
								: "something went wrong"
						);
						setIsLoading(false);
					}
				);
			}
		} else {
			ToastAlertError("Please fill all fields");
		}
	}
	const handleLogin = (e) => {
		e.preventDefault();
		const data = new FormData(e.target);
		const values = Object.fromEntries(data.entries());
		const hasEmptyValues = Object.values(values).some(value => value === '');

		if (!hasEmptyValues) {
			setIsLoading(true);
			CoreHttpHandler.request(
				"shareholder_education",
				"login",
				{
					...values
				},
				(res) => {
					localStorage.setItem("user_details", JSON.stringify(res.data.data.login.customer));
					localStorage.setItem("token", res.data.data.login.token);
					ToastAlertSuccess(res.data.data.login.message);
					setModalShow(false);
					setIsLoading(false);

					// ToastAlertSuccess("Registered Successfully");
				},
				(err) => {
					ToastAlertError(
						err?.response?.data?.message
							? err?.response.data.message
							: "something went wrong"
					);
					setIsLoading(false);

				}
			);
		} else {
			ToastAlertError("Please fill all fields");
		}
	}

	const handleModalSwitch = (val) => {
		setModalType(val);
		setTimeout(() => {
			document.querySelectorAll(".formInput").forEach(input => input.value = "");
		}, 100);
	}
	return (
		<>
			<Modal backdrop="static"
				centered
				dialogClassName="modal-90w"
				keyboard={false}
				show={modalShow}
				// onHide={() => setModalShow(false)}
				aria-labelledby="contained-modal-title-vcenter">
				<FontAwesomeIcon onClick={() => setModalShow(false)} fontSize={30} className="close_modal_icon" icon={faXmark} />
				{modalType === "SignUp" ?
					<>
						<Modal.Header className="register_modal-bg modal_head_center" >
							<Modal.Title id="contained-modal-title-vcenter">
								Register Now
							</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ padding: "5%" }} className="grid-example register_modal-bg">
							<Container>
								<Form onSubmit={handleFormSubmit} autoComplete="off">

									<Row>
										<Col xs={12} md={6}>

											<Form.Group controlId="formGroupFName">
												<Form.Label>First Name</Form.Label>
												<Form.Control autoComplete="off" name="first_name" className="formInput" placeholder="First Name" />
											</Form.Group>

										</Col>

										<Col xs={12} md={6}>

											<Form.Group controlId="formGroupLName">
												<Form.Label>Last Name</Form.Label>
												<Form.Control autoComplete="off" name="last_name" className="formInput" placeholder="Last Name" />
											</Form.Group>

										</Col>
									</Row>
									<Row>
										<Col xs={12} md={6}>

											<Form.Group controlId="formGroupEmail">
												<Form.Label>Email</Form.Label>
												<Form.Control name="email" type="email" required className="formInput" placeholder="Email" />
											</Form.Group>

										</Col>

										<Col xs={12} md={6}>

											<Form.Group controlId="formGroupPhone">
												<Form.Label>Phone</Form.Label>
												<Form.Control name="number" className="formInput" placeholder="Mobile No" />
											</Form.Group>

										</Col>
									</Row>
									<Row>
										<Col xs={12} md={6}>

											<Form.Group controlId="formGroupUsername">
												<Form.Label>Username</Form.Label>
												<Form.Control name="username" className="formInput" placeholder="Username" />
											</Form.Group>

										</Col>
										<Col xs={12} md={6}>

											<Form.Group >
												<Form.Label>Password</Form.Label>

												<InputGroup>

													<Form.Control name="password" type={showPassword ? "text" : "password"}
														className="formInput" placeholder="Password" />
													<InputGroup.Text
														onClick={() => setShowPassword(!showPassword)}
														style={{ cursor: "pointer", background: "transparent", border: "none", marginBottom: "4%" }}
													>
														{showPassword ? <FaEye size={18} /> : <RiEyeOffFill size={18} />}
													</InputGroup.Text>
												</InputGroup>
											</Form.Group>




										</Col>
										<Col xs={12} md={6}>

											<Form.Group>
												<Form.Label>Confirm Password</Form.Label>
												<Form.Control
													name="confirmPassword"
													type="password"
													className="formInput"
													placeholder="Confirm Password"
													isInvalid={!!error}
												/>
												<Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>

											</Form.Group>

										</Col>

									</Row>
									<p>Already have an account ? <a onClick={() => handleModalSwitch("Login")}>Login Now</a></p>
									<Row style={{ margin: "auto", width: "30%" }}>
										<button type="submit" className="rounded_btn" >
										{isLoading ? <Spinner animation="border" role="status">
											<span className="visually-hidden">Loading...</span>
										</Spinner> : "Register"
										}</button>
									</Row>

								</Form>

							</Container>
						</Modal.Body>
					</>
					:
					<>
						<Modal.Header className="register_modal-bg modal_head_center" >
							<Modal.Title id="contained-modal-title-vcenter">
								Login
							</Modal.Title>
						</Modal.Header>
						<Modal.Body style={{ padding: "5%" }} className="grid-example register_modal-bg">
							<Container>
								<Form onSubmit={handleLogin}>


									<Row>
										<Col xs={12} md={6}>

											<Form.Group controlId="Username">
												<Form.Label>Username</Form.Label>
												<Form.Control name="username" className="formInput" placeholder="Username" />
											</Form.Group>

										</Col>
										<Col xs={12} md={6}>

											<Form.Group controlId="Password">
												<Form.Label>Password</Form.Label>
												<InputGroup>

													<Form.Control name="password" type={showPassword ? "text" : "password"}
														className="formInput" placeholder="Password" />
													<InputGroup.Text
														onClick={() => setShowPassword(!showPassword)}
														style={{ cursor: "pointer", background: "transparent", border: "none", marginBottom: "4%" }}
													>
														{showPassword ? <FaEye size={18} /> : <RiEyeOffFill size={18} />}
													</InputGroup.Text>
												</InputGroup>
											</Form.Group>

										</Col>

									</Row>
									<p>New Here ? <a onClick={() => handleModalSwitch("SignUp")}>Register Now</a></p>
									<Row style={{ margin: "auto", width: "30%" }}>
										
										<button type="submit" className="rounded_btn" > {isLoading ? <Spinner animation="border" role="status">
											<span className="visually-hidden">Loading...</span>
										</Spinner> : "Login"
										}</button>
									</Row>
									<Link to='/forgotpassword' onClick={() => setModalShow(false)}> Forgot your password? </Link>
								</Form>

							</Container>
						</Modal.Body>




					</>
				}
			</Modal >
		</>
	);
};

export default RegisterModal;
